/**
 * Shared display utilities for compliance grid components.
 * Replaces repeated nested ternary patterns with clear lookup objects.
 */

// Frequency-based grid widths for the scrollable compliance grid
export const FREQ_MIN_WIDTHS = {
  annual: '500px',
  one_time: '500px',
  quarterly: '700px',
  monthly: '1100px',
};

export const FREQ_COL_WIDTHS = {
  annual: 'w-36',
  one_time: 'w-36',
  quarterly: 'w-32',
  monthly: 'w-24',
};

// Smaller variant used in BoardDetailPage
export const FREQ_MIN_WIDTHS_SM = {
  annual: '400px',
  one_time: '400px',
  quarterly: '600px',
  monthly: '900px',
};

export const FREQ_COL_WIDTHS_SM = {
  annual: 'w-32',
  one_time: 'w-32',
  quarterly: 'w-28',
  monthly: 'w-20',
};

/**
 * Returns CSS classes for overdue/due-soon/normal states.
 * @param {boolean} isOverdue
 * @param {boolean} isDueSoon
 * @param {Object} classMap - { overdue, dueSoon, normal }
 * @returns {string}
 */
export function dueDateClass(isOverdue, isDueSoon, classMap) {
  if (isOverdue) return classMap.overdue;
  if (isDueSoon) return classMap.dueSoon;
  return classMap.normal || '';
}
